<template>
    <DCard
        :title="__('contracts.pricing.form.discount_table_header')"
        padding
    >
        <div
            v-for="(discount, index) in modelValue"
            :key="index"
            :class="index > 0 ? 'pt-3 my-3 border-top' : 'pt-1 mb-3'"
        >
            <!-- TLD + REMOVE ROW -->
            <DFormRow
                class="align-center"
                :label="__('contracts.pricing.form.select_tld')"
                is-required
            >
                <div class="d-flex align-items-center gap-2 w-100">
                    <!-- TLD select -->
                    <DSelect
                        :id="`tld_${index}`"
                        v-model="discount.tld"
                        class="flex-grow-1"
                        :options="[
                            { value: '', label: '', disabled: true },
                            ...tldOptions
                        ]"
                        :is-valid="!errors[`domain_decoupling_discounts.${index}.tld`]"
                        :placeholder="__('contracts.pricing.form.select_tld')"
                    />

                    <!-- TLD Remove -->
                    <DButton
                        icon="trash-can-outline"
                        mini
                        variant="light"
                        color="danger"
                        @click="deleteDiscount(discount)"
                    />
                </div>

                <!-- ERROR TLD regular validation -->
                <p
                    v-if="errors[`domain_decoupling_discounts.${index}.tld`]"
                    class="error-msg"
                >
                    {{ errors[`domain_decoupling_discounts.${index}.tld`] }}
                </p>
            </DFormRow>

            <!-- DISCOUNT FIELDS ROW (after selecting TLD) -->
            <DFormRow
                :label="__('contracts.pricing.form.discount')"
                is-required
            >
                <div class="form-fields">
                    <!-- Discount name -->
                    <div class="form-field mb-3">
                        <DInput
                            v-model="discount.discount_name"
                            :placeholder="__('contracts.pricing.form.discount_name')"
                            :is-valid="!errors[`domain_decoupling_discounts.${index}.discount_name`]"
                        />
                        <p
                            v-if="errors[`domain_decoupling_discounts.${index}.discount_name`]"
                            class="error-msg"
                        >
                            {{ errors[`domain_decoupling_discounts.${index}.discount_name`] }}
                        </p>
                    </div>

                    <!-- Discount value -->
                    <div class="form-field mb-3">
                        <DInput
                            v-model="discount.discount_value"
                            type="number"
                            :placeholder="__('contracts.pricing.form.discount_value')"
                            :is-valid="!errors[`domain_decoupling_discounts.${index}.discount_value`]"
                        />
                        <p
                            v-if="errors[`domain_decoupling_discounts.${index}.discount_value`]"
                            class="error-msg"
                        >
                            {{ errors[`domain_decoupling_discounts.${index}.discount_value`] }}
                        </p>
                    </div>

                    <!-- Discount type: percentage is the only supported type -->
                    <div class="form-field mb-3">
                        <DSelect
                            :id="`discount_type_${index}`"
                            value="percentage"
                            :options="[
                                {
                                    value: 'percentage',
                                    label: __('contracts.pricing.form.discount_percentage')
                                }
                            ]"
                            :disabled="true"
                        />
                        <p
                            v-if="errors[`domain_decoupling_discounts.${index}.discount_type`]"
                            class="error-msg"
                        >
                            {{ errors[`domain_decoupling_discounts.${index}.discount_type`] }}
                        </p>
                    </div>
                </div>
            </DFormRow>
        </div>

        <!-- ADD NEW DISCOUNT -->
        <div class="d-flex justify-content-left mt-3">
            <DFab
                id="add_domain_discount"
                class="fab-up"
                color="secondary"
                icon="plus"
                :label="__('contracts.pricing.form.add_domain_discount')"
                @click="addDiscount"
            />
        </div>
    </DCard>
</template>

<script setup>
import { __ } from '~@/Composables/translation'

const props = defineProps({
    modelValue: { type: Array, required: true },
    tldOptions: { type: Array, default: () => [{ value: '', label: '' }] },
    errors: { type: Object, default: () => ({}) },
})

const emit = defineEmits(['update:modelValue'])

function getNewDiscount () {
    return {
        id: null,
        tld: null,
        discount_name: null,
        discount_value: null,
        discount_type: 'percentage'
    }
}

function addDiscount () {
    const updated = [...props.modelValue, getNewDiscount()]
    emit('update:modelValue', updated)
}

function deleteDiscount (item) {
    emit('update:modelValue', props.modelValue.filter(d => d !== item))
}
</script>

<style scoped lang="scss">

.form-fields {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
}

.form-field {
    flex: 1 1 30%;
    min-width: 180px;
}

.error-msg {
    color: #dc3545;
    font-size: 12px;
    margin: 2px 0 0;
}
</style>
